import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "../button.component";
import { PaginationEntriesInput } from "../paginationEntries";
import { useAppDispatch } from "../../core/redux";

interface IProps<TTableAction> {
  isSelected: boolean;
  isDeleting: boolean;
  pageSize: number;
  onDelete: () => void;
  buttonText: string;
  redirectPath: string;
  TableAction: TTableAction;
}
interface IReduxActions {
  setEntryCount: (payload: number) => {
    payload: number;
    type: string;
  };
}
export function TableHeader<TTableAction extends IReduxActions>({
  pageSize,
  isSelected,
  isDeleting,
  onDelete,
  buttonText,
  redirectPath,
  TableAction,
}: IProps<TTableAction>) {
  const routeHistory = useHistory();
  const dispatch = useAppDispatch();

  const redirect = useCallback(
    () => routeHistory.push(redirectPath),
    [routeHistory, redirectPath]
  );

  const onPageChange = useCallback(
    (value) => dispatch(TableAction.setEntryCount(value)),
    [dispatch, TableAction]
  );

  return (
    <div className="d-flex align-items-center mb-2">
      <Button name={buttonText} className="me-2 btn-green" onClick={redirect} />

      <div className="d-flex">
        <div className="align-self-center me-2">Show</div>
        <PaginationEntriesInput onChange={onPageChange} />
        <div className="align-self-center ms-2">entries</div>
      </div>

      <div className="d-flex justify-content-end ms-auto">
        <Button
          name="Delete selected"
          className={`btn-danger ${isSelected ? "visible" : "invisible"}`}
          disabled={isDeleting}
          onClick={onDelete}
        />
      </div>
    </div>
  );
}
